import api from '../../api/index.js'

const state = {
    
}

const getters = {

}

const actions = {
    PostFollow({commit},payload) {
        return new Promise((resolve, reject) => {
            api.post('/Follow/Post',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
    DeleteFollow({commit},payload) {
        return new Promise((resolve, reject) => {
            api.delete('/Follow/Delete',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    }

}

const mutations = {
    
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/follow.js